import React, {useCallback} from 'react';

import {useAmIApiParticipant} from '../hooks/useAmIApiParticipant';
import {useConfig} from '../config';
import {useInfinityContext} from '../hooks/useInfinityContext';
import {AccessibilitySettingsView} from '../views/AccessibilitySettings/AccessibilitySettings.view';

export const AccessibilitySettings: React.FC = () => {
    const [alwaysDisplayUIInterfaces, setAlwaysDisplayUIInterfacesConfig] =
        useConfig('alwaysDisplayUIInterfaces');

    const toggleAlwaysDisplayUIInterfaces = useCallback(() => {
        setAlwaysDisplayUIInterfacesConfig(currentValue => !currentValue, true);
    }, [setAlwaysDisplayUIInterfacesConfig]);

    const [disableKeyboardShortcuts, setDisableKeyboardShortcuts] = useConfig(
        'disableKeyboardShortcuts',
    );

    const toggleDisableKeyboardShortcuts = useCallback(() => {
        setDisableKeyboardShortcuts(currentValue => !currentValue, true);
    }, [setDisableKeyboardShortcuts]);

    const infinity = useInfinityContext();
    const amIApiParticipant = useAmIApiParticipant(infinity.getMe);

    return (
        <AccessibilitySettingsView
            alwaysDisplayUIInterfaces={alwaysDisplayUIInterfaces}
            toggleAlwaysDisplayUIInterfaces={toggleAlwaysDisplayUIInterfaces}
            amIApiParticipant={amIApiParticipant}
            disableKeyboardShortcuts={disableKeyboardShortcuts}
            toggleDisableKeyboardShortcuts={toggleDisableKeyboardShortcuts}
        />
    );
};
